// extracted by mini-css-extract-plugin
export default {"link":"BeanderBeanContent_link__oBIgy","currentBidCol":"BeanderBeanContent_currentBidCol__Bxfdv","bidRow":"BeanderBeanContent_bidRow__B2Wzo"};